/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const NestedForm = zod.strictObject({
    id: zod.number(),
    label: zod.string(),
});

export type NestedForm = zod.input<typeof NestedForm>;
export type NestedFormOutput = zod.output<typeof NestedForm>;
